module.exports = __webpack_public_path__ + "img/title1.c094a574.png";